import BowserBase from 'bowser';


const chromiumGostRegExp = new RegExp(/chromium gost/i);

export class Bowser {
    UA: string;

    Parser: Bowser.Parser.Parser;

    PlatformType: string;

    BrowserName: string;

    constructor() {
        this.UA = window.navigator.userAgent;
        this.Parser = BowserBase.getParser(this.UA);
        this.PlatformType = this.Parser.getPlatformType(true);
        this.BrowserName = this.Parser.getBrowserName();
    }

    static get BROWSER_MAP() {
        return BowserBase.BROWSER_MAP;
    }

    get mobile() {
        return this.PlatformType === BowserBase.PLATFORMS_MAP.mobile;
    }

    get desktop() {
        return this.PlatformType === BowserBase.PLATFORMS_MAP.desktop;
    }

    get tablet() {
        return this.PlatformType === BowserBase.PLATFORMS_MAP.tablet;
    }

    get chrome() {
        return this.BrowserName === BowserBase.BROWSER_MAP.chrome;
    }

    get chromiumGost() {
        return chromiumGostRegExp.test(this.UA);
    }

    get firefox() {
        return this.BrowserName === BowserBase.BROWSER_MAP.firefox;
    }

    get yandex() {
        return this.BrowserName === BowserBase.BROWSER_MAP.yandex;
    }

    get ie() {
        return this.BrowserName === BowserBase.BROWSER_MAP.ie;
    }

    get name() {
        return this.BrowserName;
    }

    satisfies(supportedBrowsers) {
        return this.Parser.satisfies(supportedBrowsers);
    }
}
